<template>

  <HeaderSection />

  <section id="formulario" class="p-10 bg-cover bg-no-repeat " :style="{ backgroundImage: 'url(' + require(`@/assets/formulario.png`) + ')' }">

    <dic class="space-y-4 text-gray-700 Mindset">

      <div class="container mx-auto p-6 max-w-6xl bg-white rounded-lg">

        <h1 class="font-bold text-center text-3xl uppercase TommyBlack">La fiesta fue reprogramada para el 22 de Novimebre</h1>
        <h1 class="font-bold text-center text-3xl uppercase TommyBlack py-5">Si ya estabas acreditado podés ir con el mismo QR</h1>
        <h1 class="font-bold text-center text-3xl uppercase TommyBlack">Si te queres acreditar podes hacerlo en la nueva página de acreditaciones</h1>


        <div class="w-full text-center py-20">
          <a href="https://acreditaciones.qreventos.com/fdd22112025" class="Abo w-full sm:w-auto px-10 py-3 mt-3 text-2xl Mindset bg-transparent border border-[#ffb700] text-[#df4753] rounded-full hover:bg-[#ffb700] shadow-lg hover:scale-110">
            ACREDITARME
          </a>
        </div>
        
        <div class="container mx-auto py-10">
          <img class="object-contain mx-auto" src="@/assets/fdd.png" style="max-width: 300px;" />
        </div>

      </div>


      
    </dic>

  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import HeaderSection from '@/components/HeaderSection.vue'

export default defineComponent({
  components: {
    HeaderSection
  }
});
</script>